const de = {
  title: 'Rollen',
  createRole: 'Rolle erstellen',
  model: {
    name: 'Rollenname',
    entitlementGroups: 'EntitlementGruppen',
    permissions: 'Berechtigungen'
  },
  modal: {
    included: 'Enthalten',
    notIncluded: 'Nicht enthalten'
  },
  deleteConfirm: {
    title: 'Wirklich löschen?',
    message: 'Wollen Sie diese Rolle wirklich löschen?'
  },
  alerts: {
    errorLoading: 'Die Rollen konnten nicht geladen werden.',
    saveFailed: 'Die Rolle konnte nicht gespeichert werden.',
    saveSuccess: 'Die Rolle wurde erfolgreich gespeichert.',
    deleteFailed: 'Die Rolle konnte nicht gelöscht werden.',
    deleteSuccess: 'Die Rolle wurde erfolgreich gelöscht.'
  }
};

export default de;
export type AccessHandlerRolesTranslation = typeof de;
